<template>
  <div class="row">
    <!-- START Page heading -->
    <div class="columns small-12">
      <h3>{{ $t("attachments") }}</h3>
      <input v-model="search" class="form-control mb-3 d-none" />
      <b-table :items="attachments" :fields="fields">
        <template #cell(dateTimeCreated)="data">
          {{ formatDate(data.item.dateTimeCreated) }}
        </template>
        <template #cell(customerAttachmentID)="data">
          <a
            :href="`#${data.item.customerAttachmentID}`"
            @click="
              download({
                attachmentID: data.item.customerAttachmentID,
                fileName: data.item.fileName,
              })
            "
            >{{ $t("download") }} <i class="fas fa-download"></i
          ></a>
        </template>
      </b-table>
    </div>
    <!-- END Page heading -->
    <div v-if="attachments.length < 1" class="columns small-12">
      <p class="text-center">
        <strong>{{ $t("noAttachmentsFound") }}</strong>
      </p>
    </div>
  </div>
</template>

<script>
import {getAttachments, downloadAttachment} from "@/services/attachments";
import dayjs from "dayjs";

export default {
  name: "ShopAttachments",
  data() {
    return {
      attachments: [],
      fields: [
        {
          key: "fileName",
          label: this.$t("filename"),
        },
        {
          key: "dateTimeCreated",
          label: this.$t("date"),
        },
        {
          key: "customerAttachmentID",
          label: this.$t("download"),
        },
      ],
      search: "",
    };
  },
  watch: {
    search() {
      this.getAttachments(this.search);
    },
  },
  created() {
    this.$store.commit("setCustomerID", {
      customerID: document.getElementById("customerid").value,
    });
    this.getAttachments();
  },
  methods: {
    async getAttachments(search) {
      this.attachments = await getAttachments({search});
    },
    formatDate(date) {
      if (date === null || date === "") return null;
      return dayjs(date).format("DD-MM-YYYY");
    },
    download({fileName, attachmentID}) {
      downloadAttachment({fileName, attachmentID});
    },
  },
};
</script>

<style scoped></style>
